// extracted by mini-css-extract-plugin
module.exports = {"container":"FormInputSelect_container__3WbrH","label":"FormInputSelect_label__1Jb2n","errorMsg":"FormInputSelect_errorMsg__1I6rq","error":"FormInputSelect_error__3QMX6"};